import React from 'react'
import _ from 'lodash'

import * as CreditsAndLimitsConstants from './../helpers/constants'

const LimitsSection = ({
  client,
  userData,
  additionalUserData,
  getUserInfo
}) => {
  const limitsSection = CreditsAndLimitsConstants.CREDITS_LIMITS_TAB[client].LIMITS_SECTION

  return (
    <div className="credits-limits-section">
      <h5 className='text-center'>Limit Breakups</h5>
      <div className='d-flex justify-content-between flex-column gap-2'>
        {
          limitsSection.map((opts, idx) => {
            const accessorValue = _.get(userData, opts.accessorKey)
            return (
              <div
                key={idx}
                className='d-flex justify-content-between'
              >
                {
                  opts.formatter({
                    client,
                    value: accessorValue,
                    userData,
                    additionalUserData,
                    getUserInfo,
                    label: opts.label
                  })
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default LimitsSection